<div class="col-12">
  <div class="col-12">
    <!-- メモボタン -->
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="parentOpenMemoModal">
      {{ $t('message.button_vehicle_dtc_note_modal') }}
    </b-button>
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="csvExport">
      {{ $t('message.file_export') }}
    </b-button>
  </div>
  <div class="col-12">
    <custom-table class="mt-2 ml-2" type="simple" useSort useStripeStyle rowSelect hasTabs currentSortkey="status"
      initSortDir="asc" :items="measuredDataItems" :columns="measuredDataColumns" @rowButtonClicked="openFFDModal">
      <template v-slot:rowButton="{ row }">
        <img v-if="row.isMultiFFD" class="ffd_icon_style" src="@/assets/img/ffd/ffd_multi.png" draggable="false" />
        <img v-else class="ffd_icon_style" src="@/assets/img/ffd/ffd_single.png" draggable="false" />
      </template>
    </custom-table>
  </div>

  <!-- FFD 一覧画面 -->
  <b-modal v-model="cancelCodeFfdModal" size="huge" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100 modal-title" :title="ffdTitle">{{ ffdTitle }}</div>
    </template>

    <cancelCode-ffd-modal v-if="cancelCodeFfdModal" :ffdTableProp="ffdTableItems" :systemProp="selectedCancelCode"
      :ffdSystem="ffdSystem" :ffdDescription="ffdDescription" :systemID="systemId" :code="ffdCode"
      :dataPlayback="dataPlayback" :dataName="measuredDataName" ref="ffd_modal">
      <template v-slot:didTestBtn>
        <b-button v-if="testModeVisible" class="clear-button" variant="primary" size="sm" @click="didTestDataExport">
          Export DID Data
        </b-button>
      </template>
    </cancelCode-ffd-modal>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" @click="closeFfdModal" class="ml-2 mr-2">
          {{ $t("message.common_button_ok") }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <div class="text-right">
    <label v-if="displayCncFunc" class="col col-md-4">
      <b-form-input type="text" v-model="displayCncFunc" class="w-100" size="sm" disabled>
        {{ displayCncFunc }}
      </b-form-input>
    </label>
    <b-button variant="primary" size="sm" @click="backToDetails">
      {{ $t('message.common_button_back') }}
    </b-button>
  </div>

  <processing-view :processing="processing"></processing-view>
</div>